import { useGetAlboCfgTipi } from '@framework/common-web/register-records/frontoffice/api/configurazione-tipo-albo/configurazione-tipo-albo.ts';
import { type AlboConfigurazioneTipoDTO } from '@framework/common-web/register-records/frontoffice/api/schemas/alboConfigurazioneTipoDTO.ts';
import { useMemo } from 'react';

/**
 * Hook per ottenere il tipo di Elenco Frontoffice.
 */
export function useRegisterRecordsTypeFo(registerRecordTypeId?: string) {
  const {
    data: registerRecordTypesData,
    isLoading: isRegisterRecordTypesLoading,
  } = useGetAlboCfgTipi({
    query: {
      enabled: !!process.env.BUILD_FLAGS_REGISTER_RECORDS,
      keepPreviousData: true,
    },
  });

  const registerRecordTypes = useMemo(() => {
    if (!registerRecordTypesData || isRegisterRecordTypesLoading) return [];
    return registerRecordTypesData;
  }, [registerRecordTypesData, isRegisterRecordTypesLoading]);

  const registerRecordType: AlboConfigurazioneTipoDTO | null = useMemo(() => {
    return (
      registerRecordTypes?.filter(type =>
        registerRecordTypeId ? type.id === registerRecordTypeId : true,
      )[0] ?? null
    );
  }, [registerRecordTypes, registerRecordTypeId]);

  return registerRecordType;
}
